import * as XLSX from 'xlsx';

export const groupByLanguagePair = (entries) => {
	const groups = {};
	// console.log('entries', entries);

	entries.forEach((entry) => {
		const key = `${entry.sourceLanguage}/${entry.targetLanguage}`;
		if (!groups[key]) {
			groups[key] = [];
		}
		groups[key].push(entry);
	});

	return groups;
};

export const parseExcelToJson = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = (event) => {
			try {
				const data = new Uint8Array(event.target.result);
				const workbook = XLSX.read(data, { type: 'array' });
				const worksheet = workbook.Sheets[workbook.SheetNames[0]];
				const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
				const headers = [];

				for (let col = range.s.c; col <= range.e.c; col++) {
					const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
					const cell = worksheet[cellAddress];
					headers.push(cell ? (cell.w || cell.v || '').toString().trim() : '');
				}

				const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

				resolve({
					headers: headers.filter((h) => h !== ''),
					data: jsonData,
				});
			} catch (error) {
				reject(error);
			}
		};

		reader.onerror = (error) => reject(error);
		reader.readAsArrayBuffer(file);
	});
};
